import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl';

const FilterCaption = (props) => {
    const intl = useIntl();

    let serversCache = useSelector(state => state.serversCache);
    let printersCache = useSelector(state => state.printersCache);
    let usersCache = useSelector(state => state.usersCache);
    let groupsCache = useSelector(state => state.usergroupsCache);
    let computersCache = useSelector(state => state.computersCache);

    let caption = useMemo(() => {

        function getParams()
        {
            let serverId = props.searchParams.get("serverId");
            if (serverId)
            {
                serverId = parseInt(serverId, 10);
            }
    
            let userId = props.searchParams.get("userId");
            if (userId)
            {
                userId = parseInt(userId, 10);
            }
    
            let computerId = props.searchParams.get("computerId");
            if (computerId)
            {
                computerId = parseInt(computerId, 10);
            }
    
            let groupId = props.searchParams.get("groupId");
            if (groupId)
            {
                groupId = parseInt(groupId, 10);
            }

            let printerId = props.searchParams.get("printerId");
            if (printerId)
            {
                printerId = parseInt(printerId, 10);
            }
    
            return [serverId, userId, computerId, groupId, printerId];
        }

        let caption = '';
        let [serverId, userId, computerId, groupId, printerId] = getParams();    

        if (serverId)
        {
            caption += intl.formatMessage({ id: "SMTP.server_name" }) + ': ';
            if (serversCache[serverId])
            {
                caption += serversCache[serverId];
            }
            else
            {
                caption += serverId;
            }

            caption += ' ';
        }
        
        if (printerId)
        {
            caption += intl.formatMessage({ id: "Printer" }) + ': ';
            if (printersCache[printerId])
            {
                caption += printersCache[printerId];
            }
            else
            {
                caption += printerId;
            }
            
            caption += ' ';            
        }
        if (userId)
        {
            caption += intl.formatMessage({ id: "User" }) + ': ';
            if (usersCache[userId])
            {
                caption += usersCache[userId];
            }
            else
            {
                caption += userId;
            }

            caption += ' ';
        }

        if (computerId)
        {
            caption += intl.formatMessage({ id: "Computer" }) + ': ';
            if (computersCache[computerId])
            {
                caption += computersCache[computerId];
            }
            else
            {
                caption += computerId;
            }

            caption += ' ';
        }

        if (groupId)
        {
            caption += intl.formatMessage({ id: "Group" }) + ': ';

            if (groupsCache[groupId])
            {
                caption += groupsCache[groupId];
            }
            else
            {
                caption += groupId;
            }

            caption += ' ';
        }

        if (!caption)
        {
            caption = String.fromCharCode(8202);
        }

        return caption;
    }, [props.searchParams, intl, printersCache, serversCache, computersCache, groupsCache, usersCache]);

    return (
        <div><h4>{caption}</h4></div>
    );
}

export default FilterCaption;